import { Widget } from '@rjsf/core'
import AutocompleteInput from './autocomplete/Autocomplete'
import InputField from './inputField/InputField'
import DropdownSelectWidget from './dropdownSelect/DropdownSelect'
import DatePickerWidget from './datePicker/DatePicker'
import RadioGroupWidget from './radioGroup/RadioGroup'
import PriceInputWidget from './priceInput/PriceInput'
import TextareaWidget from './textarea/Textarea'
import CheckboxWidget from './checkbox/Checkbox'
import DisclaimerCheckboxWidget from './checkbox/DisclaimerCheckbox'
import CheckboxesWidget from './checkboxes/Checkboxes'
import PhoneWithPrefix from './phoneWithPrefix/PhoneWithPrefix'
import PasswordWidget from './password/PasswordWidget'
import InputWithHyphen from './inputFieldWithHyphen/InputFieldWithHyphen'

type CustomComponentsMapperReturn = {
  [name: string]: Widget
}

type CustomComponentsMapperType = () => CustomComponentsMapperReturn

const CustomComponentsMapper: CustomComponentsMapperType = () => {
  return {
    TextWidget: InputField,
    Autocomplete: AutocompleteInput,
    SelectWidget: DropdownSelectWidget,
    DateWidget: DatePickerWidget,
    RadioWidget: RadioGroupWidget,
    PriceInput: PriceInputWidget,
    TextareaWidget: TextareaWidget,
    CheckboxWidget: CheckboxWidget,
    DisclaimerCheckbox: DisclaimerCheckboxWidget,
    CheckboxesWidget: CheckboxesWidget,
    PhoneWithPrefix: PhoneWithPrefix,
    PasswordWidget: PasswordWidget,
    InputWithHyphen: InputWithHyphen,
  }
}

export default CustomComponentsMapper
